import * as React from 'react';

export default (props: { field: { name: string, value: string, id: string, label: string, required: boolean, extra: string }, onChange: (id: string, value: any) => void }) => {
    const handleChange = (event: any) => {
        const target = event.target;
        const value = target.value;
        props.onChange(props.field.id, value);
    };
    let extra: any = {}
    try {
        extra = JSON.parse(props.field.extra)
    } catch (ex) { }
    return (
        <div className="formrow">
            <div className="formcol">
                <label className="font-weight-bold text-muted"><u>{props.field.label}{props.field.required ? '*' : ''}</u></label>
                <small className="form-text text-muted pb-3">{extra && extra.help}</small>
                <input name={props.field.name} type="text" value={props.field.value || ''} onChange={handleChange} autoComplete="off" />
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/client/pages/Input.tsx